var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Table } from "../../../../../Components/UI";
import { TableTitle } from "../TableTitle";
import { PXTableFooter } from "../PXTableFooter";

import { columns } from "./TableElements";
import { FilterSidePanel } from "../FilterSidePanel";








const EntitiesTable = ({
  pxEntitiesData,
  onSelectionChange,
  sourceTemplate,
  filters
}) => /*#__PURE__*/
_jsx(Table, {
  data: pxEntitiesData,
  columns: columns,
  enableSelections: true,
  header: /*#__PURE__*/
  _jsx(TableTitle, {
    items: sourceTemplate ? [sourceTemplate] : [],
    Buttons: filters.length > 0 && /*#__PURE__*/_jsx(FilterSidePanel, { availableFilters: filters }) }
  ),

  onChange: ({ selectedRows }) => {
    onSelectionChange(pxEntitiesData.filter((ex) => ex.rowId in selectedRows));
  },
  defaultSorting: [{ id: '_id', desc: false }],
  footer: /*#__PURE__*/_jsx(PXTableFooter, { totalPages: 10, total: 100, currentDataLength: 10 }) }
);


export { EntitiesTable };